const ProductCPTypes = {
  DAM_ALL_PRODUCT_LIST: 'DAM_ALL_PRODUCT_LIST',
  FETCH_DAM_LIST: 'FETCH_DAM_LIST',
  DAM_TAGS_LIST: 'DAM_TAGS_LIST',
  DAM_EDIT_DATA: 'DAM_EDIT_DATA',
  DAM_CLEAR_REDUCER: 'DAM_CLEAR_REDUCER',
  SET_ARCHIVED_FILES_FOLDERS: 'SET_ARCHIVED_FILES_FOLDERS',
  SET_FILTER_SORT_DATA: 'SET_FILTER_SORT_DATA',
  SET_DELETED_FILES: 'SET_DELETED_FILES',
  DAM_SET_FILTER_SORT_DATA: 'DAM_SET_FILTER_SORT_DATA',
  DAM_ALL_FOLDER_LIST: 'DAM_ALL_FOLDER_LIST',
};

export default ProductCPTypes;
